import { ApiUtil as api } from '@/utils/api.util.js'

export class FirmService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/firms/'

  static all (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }
  static allFirms (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'all', queryParams)
  }
  static store (data = {}) {
    return api.post(this.URL + this.RESOURCE, data)
  }

  static show (id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id, queryParams ).then(
    // return api.get(this.URL + this.RESOURCE + id, { params: queryParams }).then(
      data => {
        return data
      },
      error => {
        throw error
      }
    )
  }

  static update (id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id, data)
  }

  static postUpdate (id, data = {}) {
    // PHP can't seem to parse multi part form data unless the request method is POST
    // https://github.com/laravel/framework/issues/13457#issuecomment-455570274
    if (data instanceof FormData) {
      data.append('_method', 'PUT')
    }

    return api.post(this.URL + this.RESOURCE + id, data)
  }

  static delete (id) {
    return api.delete(this.URL + this.RESOURCE + id)
  }

  static archive (id) {
    return api.put(this.URL + this.RESOURCE + id + '/archive')
  }

  static restore (id) {
    return api.put(this.URL + this.RESOURCE + id + '/restore')
  }

  static parents (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'parents', queryParams)
  }

  static children (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'children', queryParams)
  }

  static firmAssociations (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'firm-associations', queryParams)
  }

  static childFirmAssociations (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'child-firm-associations', queryParams)
  }

  static attachChildren (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/attach-children', queryParams)
  }

  static rate (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/rate', queryParams)
  }

  static notFirmFirm (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'firm/not/firm-firm', queryParams)
  }

  static attachOrCreate (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'firm/attach/or/create', queryParams)
  }


  static updateLogo (data = {}) {

    if (data instanceof FormData) {
    
      data.append('_method', 'PUT')
    
    }

    return api.post(this.URL + this.RESOURCE + 'update/logo', data)
 
  }

  static updatePartial (id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/partial', queryParams)
  }

  static getAll (queryParams = {}) {

    return api.get(this.URL + this.RESOURCE + 'get/all', queryParams)
  
  }

  static getPublicAll (queryParams = {}) {

    return api.get(this.URL + this.RESOURCE + 'public/all', queryParams)
  
  }
  
  static attachRole (queryParams = {}) {

    return api.post(this.URL + this.RESOURCE + 'attach/role', queryParams)
  
  }
  static getHasAtribute (queryParams = {}) {

    return api.get(this.URL + this.RESOURCE + 'get/has-attribute', queryParams)
  
  }
  static getPortal (id) {
    return api.get(this.URL + this.RESOURCE + 'get/portal/' + id)
  }

  static findAssociated (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'find/associated', queryParams)
  }

  static listTags(id) {
    return api.get(this.URL + this.RESOURCE + id + '/tags');
  }

  static createTag(id, data = {}) {
    return api.post(this.URL + this.RESOURCE + id + '/tags', data);
  }

  static archiveTag(id, tagId) {
    return api.put(this.URL + this.RESOURCE + id + '/tags/' + tagId + '/archive');
  }

  static unarchiveTag(id, tagId) {
    return api.put(this.URL + this.RESOURCE + id + '/tags/' + tagId + '/unarchive');
  }

  static archiveCodes(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/archive-codes', data);
  }

  static restoreCodes(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/restore-codes', data);
  }

  static canBeTerminated(id, params = {}) {
    return api.get(this.URL + this.RESOURCE + id + '/can-be-terminated', params);
  }

  static terminate(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/terminate', data);
  }
}






// WEBPACK FOOTER //
// ./src/services/firm.service.js